import React from "react";
import { Link } from "react-router-dom";
import images from "../../../../utilities/images/images";
import "./QuestionBankCreatePaper.scss";

const QuestionBankCreatePaper = () => {
  return (
    <>
      <div className="d-flex align-items-center q_bank_banner">
        <div>
          <img src={images.acps_banner} alt="banner" />
        </div>
        <div>
          <p>Unlimited Question Bank</p>
          <p>
            Create your <strong>Own Customized Test & Practice</strong>{" "}
            unlimited times with <span>FREE</span> access
          </p>
        </div>
        <div className="doubts_button">
          <Link to={{ pathname: "/question_bank_form" }}>
            <img src={images.acps_banner_plus} alt="plus" />
            Create Paper
          </Link>
        </div>
      </div>
    </>
  );
};

export default QuestionBankCreatePaper;
